// eslint-disable-next-line react/prop-types
export function Container({ children }) {
  return (
    <div className='container'>
      {children}
    </div>
  );
}
